/** Milliseconds since `startedAt` (a `performance.now()` reading), rounded to a whole number. */
export const elapsedMs = (startedAt: number): number => Math.round(performance.now() - startedAt);

/** Runs `operation` and returns its result with how long it took, in whole milliseconds. */
export const measureAsync = async <T>(operation: () => Promise<T>): Promise<{ value: T; ms: number }> => {
	const startedAt = performance.now();
	const value = await operation();
	return { value, ms: elapsedMs(startedAt) };
};
